import { z } from 'zod';
import { MAX_CUSTOM_INSTRUCTIONS_LENGTH } from '../constants';

// MBA character limits
export const MBA_LIMITS = {
  title: 200,
  brand: 50,
  bullet_one: 256,
  bullet_two: 256,
  description: 2000,
} as const;

// Prohibited characters in MBA listings
export const MBA_PROHIBITED_CHARS = ['!', '$', '?', '_', '^', '{', '}', '<', '>', '|'] as const;

export const fieldSchema = z.enum(['title', 'brand', 'bullet_one', 'bullet_two', 'description']);

export const listingUpdateSchema = z
  .object({
    title: z.string().max(MBA_LIMITS.title).optional(),
    brand: z.string().max(MBA_LIMITS.brand).optional(),
    bullet_one: z.string().max(MBA_LIMITS.bullet_one).optional(),
    bullet_two: z.string().max(MBA_LIMITS.bullet_two).optional(),
    description: z.string().max(MBA_LIMITS.description).optional(),
  })
  .refine((data) => Object.values(data).some((v) => v !== undefined), {
    message: 'At least one field must be provided',
  });

export const fieldRegenerateSchema = z.object({
  field: fieldSchema,
  custom_instructions: z.string().max(MAX_CUSTOM_INSTRUCTIONS_LENGTH).optional(),
});

export type Field = z.infer<typeof fieldSchema>;
export type ListingUpdate = z.infer<typeof listingUpdateSchema>;
export type FieldRegenerate = z.infer<typeof fieldRegenerateSchema>;
